// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"SearchInput_searchInput__3a-ge","searchIcon":"SearchInput_searchIcon__1uZrT"};